import { render, staticRenderFns } from "./InformationTab.vue?vue&type=template&id=b83dd4a0"
import script from "./InformationTab.vue?vue&type=script&lang=js"
export * from "./InformationTab.vue?vue&type=script&lang=js"
import style0 from "./InformationTab.vue?vue&type=style&index=0&id=b83dd4a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports